module.exports = __webpack_public_path__ + "static/img/智能报账2.8395251e.png";